import React, { useState } from 'react'
import { addWeeks } from 'date-fns'
import { Repeat } from 'lucide-react'
import { Alert, Button, Field } from '../../components/ui'
import { SNAP_MINUTES, WEEKDAYS, toDateInput } from './shared'

function AgreementForm({ courts, onSubmit, submitting, onCancel, error }) {
  const today = new Date()
  const [form, setForm] = useState({
    phone: '',
    name: '',
    title: 'Fast hallbooking',
    courtId: '',
    weekdays: [today.getDay() === 0 ? 7 : today.getDay()],
    startTime: '18:00',
    endTime: '19:00',
    startDate: toDateInput(today),
    endDate: toDateInput(addWeeks(today, 10)),
    locationText: '',
    description: ''
  })
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }))
  const toggleDay = (d) =>
    setForm((f) => ({ ...f, weekdays: f.weekdays.includes(d) ? f.weekdays.filter((x) => x !== d) : [...f.weekdays, d] }))
  const submit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }
  return (
    <form className="rt-form" onSubmit={submit}>
      <div className="alert alert-info rt-f-full" role="note">
        <Repeat size={18} strokeWidth={1.9} aria-hidden="true" />
        <div>En fast avtale booker en person ukentlig. Hver gang blir en egen utleie i kalenderen.</div>
      </div>
      <Field label="Telefon" className="rt-f-half" hint="Finner brukeren i Spelaren">
        <input type="tel" inputMode="tel" value={form.phone} onChange={set('phone')} placeholder="912 34 567" />
      </Field>
      <Field label="Navn" className="rt-f-half" hint="Hvis personen ikke har appen">
        <input value={form.name} onChange={set('name')} placeholder="F.eks. Per Hansen" />
      </Field>
      <Field label="Tittel *" className="rt-f-half">
        <input value={form.title} onChange={set('title')} required maxLength={200} />
      </Field>
      <Field label="Hall" className="rt-f-half">
        <select value={form.courtId} onChange={set('courtId')}>
          <option value="">Ingen bestemt hall</option>
          {courts.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </Field>
      <fieldset className="rt-fieldset rt-f-full">
        <legend className="field-label">Ukedager *</legend>
        <div className="rt-weekdays">
          {WEEKDAYS.map((d) => {
            const on = form.weekdays.includes(d.value)
            return (
              <button
                type="button"
                key={d.value}
                className={`rt-day ${on ? 'is-on' : ''}`}
                aria-pressed={on}
                onClick={() => toggleDay(d.value)}
              >
                {d.label}
              </button>
            )
          })}
        </div>
      </fieldset>
      <Field label="Fra kl. *" className="rt-f-quarter">
        <input type="time" value={form.startTime} onChange={set('startTime')} required step={SNAP_MINUTES * 60} />
      </Field>
      <Field label="Til kl. *" className="rt-f-quarter">
        <input type="time" value={form.endTime} onChange={set('endTime')} required step={SNAP_MINUTES * 60} />
      </Field>
      <Field label="Første dato *" className="rt-f-quarter">
        <input type="date" value={form.startDate} onChange={set('startDate')} required />
      </Field>
      <Field label="Siste dato *" className="rt-f-quarter">
        <input type="date" value={form.endDate} onChange={set('endDate')} required />
      </Field>
      <Field label="Info" className="rt-f-full">
        <textarea rows={2} value={form.description} onChange={set('description')} placeholder="F.eks. nøkkel hentes i resepsjonen" maxLength={5000} />
      </Field>
      {error && <Alert tone="error" className="rt-f-full">{error}</Alert>}
      <div className="rt-f-full rt-form-foot">
        {onCancel && <Button variant="tertiary" onClick={onCancel}>Avbryt</Button>}
        <Button
          type="submit"
          variant="primary"
          disabled={submitting || form.weekdays.length === 0 || (!form.phone.trim() && !form.name.trim())}
        >
          {submitting ? 'Oppretter…' : 'Opprett avtale'}
        </Button>
      </div>
    </form>
  )
}

export default AgreementForm
